<div class="pv-margin pv-main pv-copy">
  <h1 class="pv-page-title">Refresh item</h1>
  <h2>Triggered refresh of item {{appItemId}} of app {{appId}}!</h2>

  <div *ngIf="error" class="pv-warn">
    {{ error }}
  </div>
</div>
